import * as React from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Stack from "@mui/joy/Stack";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { add, LogsLookup, updateClient } from "../../service/clientService";
import { Button } from "primereact/button";
import DropdownApi from "../../components/DropdownApi";
import { UserSession } from "../../models/UserSession";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import { Grid } from "@mui/material";
import ImageS3Upload from "../../components/ImageS3Upload";
import { placeholder } from "../../assets/placeholder";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { InputIcon } from "primereact/inputicon";
import { InputTextarea } from "primereact/inputtextarea";
import { addSubContractor, updateSubContractor } from "../../service/subContractorService";
import { InputText } from "primereact/inputtext";
import useApiService from "../../hooks/useApiService";
import { useToast } from "../../context/ToastContext";
import { SubContractor } from "../../models/subcontractor.interface";

export default function SubContractorAdd(modalProps: any) {
  const record = modalProps.record || {};
  const toast = useToast();

  const { loading: creatingSubcontractor, fetchData: createSubcontractor } =
    useApiService<SubContractor>({
      url: "sub_contractor",
      fetchOnMount: false,
      method: "POST",
      onSuccess: data => {
        toast("success", "Sub Contractor added successfully.");
        modalProps.callback && modalProps.callback(data);
      },
      onError: error => {
        const message = error.message || "Something went wrong, please try again later.";
        toast("error", message);
      },
    });
  async function addSub() {
    if (!managerMobile) {
      toast("warn", "Please enter manager contact number.");
      return;
    }
    let createObject: any = {
      name,
      ceo_name: ceoName,
      ceo_surname: ceoSurname,
      ceo_email: ceoEmail,
      ceo_mobile: ceoMobile,
      manager_name: managerName,
      manager_surname: managerSurname,
      manager_email: managerEmail,
      manager_mobile: managerMobile,
      user_id: userId,
      s3_key: !!file ? `sub-contractor/${id}` : undefined,
      fund_registration_number: fundRegistration,
      vat_registration_number: vatRegistration,
      company_registration_number: companyRegistration,
      scope_of_work: scopeOfWork
    };
    // modalProps.setGlobalLoading(true);
    if (record?.id) {
      updateSubContractor(createObject, record?.id).then((r: any) => {
        modalProps.setGlobalLoading(false);
        modalProps.toast.current.show({
          severity: "success",
          summary: "Sub Contractor Updated Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setReload(!modalProps.reload);
      });
      return;
    }
    await createSubcontractor({
      payload: createObject,
    });
  }

  const session: UserSession = modalProps.session;

  const id = modalProps?.uuid;

  const [name, setName] = React.useState(record?.name || "");

  const [ceoName, setCeoName] = React.useState(record?.ceo_name || "");
  const [ceoSurname, setCeoSurname] = React.useState(record?.ceo_surname || "");
  const [ceoEmail, setCeoEmail] = React.useState(record?.ceo_email || "");
  const [ceoMobile, setCeoMobile] = React.useState(record?.ceo_mobile || "");

  const [managerName, setManagerName] = React.useState(record?.manager_name || "");
  const [managerSurname, setManagerSurname] = React.useState(record?.manager_surname || "");
  const [managerEmail, setManagerEmail] = React.useState(record?.manager_email || "");
  const [managerMobile, setManagerMobile] = React.useState(record?.manager_mobile || "");

  const [scopeOfWork, setScopeOfWork] = React.useState(record?.scope_of_work || "");

  const [vatRegistration, setVatRegistration] = React.useState(
    record?.vat_registration_number || ""
  );
  const [companyRegistration, setCompanyRegistration] = React.useState(
    record?.company_registration_number || ""
  );
  const [fundRegistration, setFundRegistration] = React.useState(
    record?.fund_registration_number || ""
  );

  const [fundShowValidation, setFundShowValidation] = React.useState(false);
  const [fundIdError, setFundIdError] = React.useState(false);
  const [fundIdLoader, setFundIdLoader] = React.useState(false);

  const [certificateNumber, setCertificateNumber] = React.useState("");
  const [expiryDate, setExpiryDate] = React.useState("");
  const [issueDate, setIdIssueDate] = React.useState("");
  const [tradeName, setTradeName] = React.useState("");

  const [userId, setUserId] = React.useState(record?.user_id || "");
  const [photo, setPhoto] = React.useState(record?.photo || placeholder);
  const [file, setFile] = React.useState<File>();
  const [activeStep, setActiveStep] = React.useState(0);

  const stepperRef = React.useRef<any>(null);

  React.useEffect(() => {
    if (record?.id && !record?.s3_key && !!file) {
      updateClient(
        {
          s3_key: `client/${id}`,
        },
        record?.id
      ).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Client Image Uploaded Successfully",
          life: 3000,
        });
        modalProps.setReload(!modalProps.reload);
      });
      return;
    }
  }, [file]);

  async function Next() {
    setActiveStep(activeStep + 1);
    stepperRef?.current?.nextCallback();
  }

  async function Back() {
    setActiveStep(activeStep - 1);
    stepperRef?.current?.prevCallback();
  }

  async function LogsVerifyID() {
    if (!fundRegistration) return;
    setFundIdLoader(true);
    setFundShowValidation(true);
    LogsLookup(fundRegistration)
      .then((r: any) => {
        console.log("LogsVerifyID r == ", r);
        setFundIdLoader(false);
        if (!r?.certificateNumber) {
          setFundIdError(true);
          return;
        }
        setCertificateNumber(r.certificateNumber);
        setExpiryDate(r.expiryDate);
        setIdIssueDate(r.issueDate);
        setTradeName(r.tradeName);
        setFundIdError(false);
      })
      .catch(error => {
        setFundIdLoader(false);
        setFundIdError(true);
      });
  }

  return (
    <React.Fragment>
      <Stepper ref={stepperRef} linear={true}>
        <StepperPanel header="Details">
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "2rem",
                gap: "2rem",
              }}
            >
              <div>
                <FormControl>
                  <ImageS3Upload
                    photo={photo}
                    setPhoto={setPhoto}
                    s3Key={`sub-contractor/${id}`}
                    file={file}
                    setFile={setFile}
                  />
                </FormControl>
              </div>

              <div style={{ width: "100%" }}>
                <FormControl>
                  <FormLabel>
                    Sub Contractor Name<div style={{ color: "red" }}>*</div>
                  </FormLabel>
                  <Input
                    value={name}
                    size="sm"
                    placeholder="Sub Contractor Name"
                    onChange={e => setName(e.target.value)}
                  />
                </FormControl>
              </div>
            </div>

            <Grid item xs={12}>
              <FormLabel style={{ marginBottom: 10 }}>Scope Of Work</FormLabel>
              <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
                <InputTextarea
                  className="p-inputtext-sm PrimeSmallInput"
                  value={scopeOfWork}
                  onChange={e => setScopeOfWork(e.target.value)}
                  rows={5}
                  cols={30}
                  placeholder="Please enter scope of work"
                />
              </FormControl>
            </Grid>
          </div>
        </StepperPanel>
        <StepperPanel header="Registration">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl>
                <FormLabel>VAT Registration Number</FormLabel>
                <Input
                  value={vatRegistration}
                  size="sm"
                  placeholder="VAT Number"
                  onChange={e => setVatRegistration(e.target.value)}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl>
                <FormLabel>Company Registration Number</FormLabel>
                <Input
                  value={companyRegistration}
                  size="sm"
                  placeholder="Registration Number"
                  onChange={e => setCompanyRegistration(e.target.value)}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl>
                <FormLabel>
                  Compensation Fund Registration Number (Letter of Good Standing){" "}
                  <a
                    style={{ marginLeft: 15 }}
                    href="https://cfonline.labour.gov.za/VerifyLOGS"
                    target="_blank"
                  >
                    Search
                  </a>
                </FormLabel>
                <Input
                  size="sm"
                  placeholder="Registration Number"
                  value={fundRegistration}
                  onChange={e => setFundRegistration(e.target.value)}
                  onBlur={LogsVerifyID}
                  endDecorator={
                    fundIdLoader ? (
                      <InputIcon className="pi pi-spin pi-spinner" />
                    ) : !fundShowValidation ? (
                      ""
                    ) : fundIdError ? (
                      <InputIcon className="pi pi-times-circle" style={{ color: "red" }} />
                    ) : (
                      <InputIcon className="pi pi-verified" style={{ color: "green" }} />
                    )
                  }
                />
              </FormControl>
            </Grid>
          </Grid>
          <br />
          {fundIdError || !certificateNumber ? (
            ""
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Certificate Number</FormLabel>
                  <Input
                    value={certificateNumber}
                    size="sm"
                    placeholder="Certificate Number"
                    readOnly
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Trade Name</FormLabel>
                  <Input value={tradeName} size="sm" placeholder="Trade Name" readOnly />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Issue Date</FormLabel>
                  <Input value={issueDate} size="sm" placeholder="Issue Date" readOnly />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Expiry Date</FormLabel>
                  <Input value={expiryDate} size="sm" placeholder="Expiry Date" readOnly />
                </FormControl>
              </Grid>
            </Grid>
          )}
        </StepperPanel>
        <StepperPanel header="CEO/CEO Assistant">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                <FormLabel style={{ marginBottom: 10 }}>Name</FormLabel>
                <InputText
                  value={ceoName}
                  onChange={e => setCeoName(e.target.value)}
                  type="text"
                  className="p-inputtext-sm PrimeSmallInput"
                  placeholder="Please enter name"
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                <FormLabel style={{ marginBottom: 10 }}>Surname</FormLabel>
                <InputText
                  value={ceoSurname}
                  onChange={e => setCeoSurname(e.target.value)}
                  type="text"
                  className="p-inputtext-sm PrimeSmallInput"
                  placeholder="Please enter surname"
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <FormLabel>Contact number</FormLabel>
                <PhoneInput
                  defaultCountry="za"
                  value={ceoMobile}
                  style={{ width: "100%" }}
                  onChange={e => setCeoMobile(e)}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel>
                  Email<div style={{ color: "red" }}>*</div>
                </FormLabel>
                <Input
                  size="sm"
                  type="email"
                  startDecorator={<EmailRoundedIcon />}
                  placeholder="email"
                  value={ceoEmail}
                  onChange={e => setCeoEmail(e.target.value)}
                  sx={{ flexGrow: 1 }}
                />
              </FormControl>
            </Grid>
          </Grid>
        </StepperPanel>
        <StepperPanel header="Manager">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                <FormLabel style={{ marginBottom: 10 }}>Name</FormLabel>
                <InputText
                  value={managerName}
                  onChange={e => setManagerName(e.target.value)}
                  type="text"
                  className="p-inputtext-sm PrimeSmallInput"
                  placeholder="Please enter name"
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                <FormLabel style={{ marginBottom: 10 }}>Surname</FormLabel>
                <InputText
                  value={managerSurname}
                  onChange={e => setManagerSurname(e.target.value)}
                  type="text"
                  className="p-inputtext-sm PrimeSmallInput"
                  placeholder="Please enter surname"
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <FormLabel>Contact number <div style={{ color: "red" }}>*</div></FormLabel>
                <PhoneInput
                  defaultCountry="za"
                  value={managerMobile}
                  style={{ width: "100%" }}
                  onChange={e => setManagerMobile(e)}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel>
                  Email<div style={{ color: "red" }}>*</div>
                </FormLabel>
                <Input
                  size="sm"
                  type="email"
                  startDecorator={<EmailRoundedIcon />}
                  placeholder="email"
                  value={managerEmail}
                  onChange={e => setManagerEmail(e.target.value)}
                  sx={{ flexGrow: 1 }}
                />
              </FormControl>
            </Grid>
          </Grid>
        </StepperPanel>
      </Stepper>
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          {activeStep > 0 ? (
            <Button
              type="button"
              icon="pi pi-arrow-left"
              label="Back"
              className="p-button-outlined"
              size="small"
              style={{ position: "absolute", fontSize: "small", right: 100 }}
              onClick={() => Back()}
              disabled={creatingSubcontractor}
            />
          ) : (
            ""
          )}
          {activeStep != 3 ? (
            <Button
              type="button"
              icon="pi pi-arrow-right"
              label="Next"
              className="p-button-outlined"
              size="small"
              style={{ position: "absolute", fontSize: "small", right: 0 }}
              onClick={() => Next()}
            />
          ) : (
            <Button
              type="button"
              icon="pi pi-save"
              label="Save"
              className="p-button-outlined"
              size="small"
              style={{ position: "absolute", fontSize: "small", right: 0, color: "#2dd36f" }}
              loading={creatingSubcontractor}
              disabled={creatingSubcontractor}
              onClick={() => addSub()}
            />
          )}
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
